import { render } from "./BtnRegist.vue?vue&type=template&id=324b678c&scoped=true"
import script from "./BtnRegist.vue?vue&type=script&lang=js"
export * from "./BtnRegist.vue?vue&type=script&lang=js"

import "./BtnRegist.vue?vue&type=style&index=0&id=324b678c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324b678c"]])

export default __exports__